import React, { useState, useEffect } from "react";
import "../../../../index.css";
import { Grid, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, Divider, Select, MenuItem, FormControl, Box } from "@mui/material";
import ContentWrapper from '../../../../common/components/ContentWrapper';
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";

import { useTranslation } from 'react-i18next';
import * as formatters from '../../../../utils/util';
import UserAvatar from '../../../../assets/icons/user-avatar.svg';
import Edit from '../../../../assets/icons/edit.svg';
import CloseIcon from '../../../../assets/icons/modal-close-icon.svg';
import UploadImage from '../../../../assets/icons/upload-icon.svg';
import AvatarIcon from "../../../../common/components/Avatar";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { connect, useSelector, useDispatch  } from 'react-redux';
import { bindActionCreators } from "redux";
import { getProfileInfo, getRelationshipList, updateProfileInfo, updateProfilePicture, updateProfileInHeader } from '../redux/actions';


const EditProfilePage = (props) => {
    const { getProfileInfo,getRelationshipList,relationship, userInfoData, updateProfileInfo, updatedData, updateProfilePicture, profilePictureData, profilePictureError, isUpdatingUserInfo } = props;


    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const userDetails = window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : null;

  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const [user, setUser] = useState(null);
  const [userObject,setUserObject] = useState(null);
  const [name, setName] = useState(null);

  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUrlAvatar1, setImageUrlAvatar1] = useState(null);
  const [imageUrlAvatar, setImageUrlAvatar] = useState(null);

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [dob, setDOB] = useState(null);
  const [ssn, setSSN] = useState('');
  const [relation, setRelation] = useState(null);
  const [phoneNumber, setphoneNumber] = useState(null);
  const [altPhoneNumber, setAltPhoneNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [altEmail, setAltEmail] = useState(null);
  const [emergencyContactName, setEmergencyContactName] = useState(null);
  const [emergencyContactNumber, setEmergencyContactNumber] = useState(null);
  const [s3Key, setS3Key] = useState(null);
  const [firstNameErr, setFirstNameErr] = useState('');
  const [lastNameErr, setLastNameErr] = useState('');
  const [dobErr, setDOBErr] = useState('');
  const [ssnErr, setSSNErr] = useState('');
  const [relationErr, setRelationErr] = useState('');
  const [phoneNumberErr, setphoneNumberErr] = useState('');
  const [altPhoneNumberErr, setAltPhoneNumberErr] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [altEmailErr, setAltEmailErr] = useState('');
  const [emergencyContactNameErr, setEmergencyContactNameErr] = useState('');
  const [emergencyContactNumberErr, setEmergencyContactNumberErr] = useState('');

  const [openPhotoUploadModal, setOpenPhotoUploadModal] = useState(false);
  const[image, setImage] = useState(null);
  const[previewUrl, setPreviewUrl] = useState(""); 
  const [isAvatarSelection, setIsAvatarSelection] = useState(false);
  const [selectedAvatarData, setSelectedAvatarData] = useState(null);

  useEffect(()=>{
    getProfileInfo();
    getRelationshipList();
  },[])
  

  useEffect(()=>{
    if(userInfoData && userInfoData.status === 200){
        setUser(userInfoData.data);
       

        const user = userInfoData.data;
        if(user){
          updateProfileInHeader(user);

          setUserObject(user);
          const userName =( (user?.firstName  && user?.firstName !== null  ? user?.firstName : '')  + 
                           ( user?.middleName && user?.middleName !== null ? (' '+user.middleName)  : "") +
                           (user?.lastName && user?.lastName !== null ? (' '+user.lastName ) : ""))
          
          setEmail(user?.emailId)
          setName(userName)
          setFirstName(user?.firstName)
          setLastName(user?.lastName)
          setDOB(user?.dateOfBirth || '');
          setSSN(user?.socialSecurityNo);
          setRelation(user?.relationshipCode);
          setphoneNumber(user?.phoneNo);
          setAltPhoneNumber(user?.altPhoneNo);
          setAltEmail(user?.altEmailId);
          setEmergencyContactName(user?.emergencyContactName);
          setEmergencyContactNumber(user?.emergencyContactNo);
          setImageUrlAvatar(user?.image_PreSignedUrl)
          setS3Key(user?.image)
        }
        
    }
  },[userInfoData])

  useEffect(()=>{
    if(updatedData){
      navigate('/profile', {state:{dontShowSecurityLock : true}});
    }
  },[updatedData])
  console.log(relation, '00000')
  useEffect(()=>{
    if(profilePictureData && profilePictureData.status === 200){
      setS3Key(profilePictureData?.data?.s3Key);
      setImageUrlAvatar(imageUrlAvatar1);
      setOpenPhotoUploadModal(false);
      setPreviewUrl('');
    }
    // if(profilePictureData && profilePictureData.status !== 200){
    // }
  },[profilePictureData, profilePictureError])

  const filteredDataSelf = {};
  const filteredDataNotSelf = {};
    for (const key in relationship) {
      if (key === "self") {
        filteredDataSelf[key] = relationship[key];
      } else {
        filteredDataNotSelf[key] = relationship[key];
      }
    }

  const handleFile = file => {
    //you can carry out any file validations here...
    setImage(file);
    setPreviewUrl(URL.createObjectURL(file));
    setImageUrlAvatar1(URL.createObjectURL(file))
    setImageUrlAvatar(URL.createObjectURL(file))
}
const handleOnDrop = event => {
  event.preventDefault(); 
  event.stopPropagation(); 
  //let's grab the image file
  setIsAvatarSelection(false);
  let imageFile = event.dataTransfer.files[0];
  handleFile(imageFile);
}

const handleDragOver = event => {
  event.preventDefault();
}
  const saveAvatarIcon = (data) => {
    if(isAvatarSelection){
      setS3Key(selectedAvatarData?.imageSrcKey);
      setOpenPhotoUploadModal(false);
      setPreviewUrl('');
    }else{
      let fd = new FormData();
      fd.set("userId", user.id);
      fd.set("file", image);
      fd.set("accountId", user?.accountId);
      fd.set('fileTag',  'ProfilePicture')
      updateProfilePicture(fd);
    }
  };

  const handleClose= () => {
    setOpenPhotoUploadModal(false);
    setPreviewUrl('');
    setImageUrlAvatar1('');
    setImageUrlAvatar('');
    setIsAvatarSelection(false);
    setSelectedAvatarData(null);
    setS3Key(userObject?.image)
    setImageUrlAvatar(userObject?.image_PreSignedUrl)
  };

  useEffect(() => {
      if (selectedImage) {
        setImageUrlAvatar1(URL.createObjectURL(selectedImage));
        setPreviewUrl(URL.createObjectURL(selectedImage));
        setImageUrlAvatar(URL.createObjectURL(selectedImage));
        setIsAvatarSelection(false);
      }
    }, [selectedImage]);

    const onChangeInput = (e, type) => {
      if(type === 'firstName') {
        setFirstName(e.target.value)
      } else if(type === 'lastName') {
        setLastName(e.target.value)
      } else if(type === 'dob') {
        let date = e
      if(e){
        date = moment(e).format('MM-DD-YYYY')
      }
        setDOB(date);
      } else if(type === 'ssn') {
        let ssnNum = formatters.isNumaric(e.target.value)
        setSSN(ssnNum);
      } else if(type === 'relation') {
        setRelation(e.target.value)
      } else if(type === 'phoneNumber') {
        setphoneNumber(e.target.value)
      } else if(type === 'altPhoneNumber') {
        setAltPhoneNumber(e.target.value)
      } else if(type === 'email') {
        setEmail(e.target.value)
      }else if(type === 'altEmail') {
        setAltEmail(e.target.value)
      } else if(type === 'emergencyContactName') {
        setEmergencyContactName(e.target.value)
      } else if(type === 'emergencyContactNumber') {
        setEmergencyContactNumber(e.target.value)
      } 
    }
    const resetErrorMessage = () => {
        setFirstNameErr('');
        setLastNameErr('');
        setDOBErr('');
        setSSNErr('');
        setRelationErr('');
        setphoneNumberErr('');
        setAltPhoneNumberErr('');
        setEmailErr('');
        setAltEmailErr('');
        setEmergencyContactNameErr('');
        setEmergencyContactNumberErr('');
    }
   
    const onSave = () => {
      let isInValid = false;
      resetErrorMessage();
      const nameRegex = /^[A-Za-z. ]+$/;
    
      if (!firstName?.trim().length) {
        setFirstNameErr('This is required.');
        isInValid = true;
      }else if(!nameRegex.test(firstName)){
        setFirstNameErr('First Name should contails letters and spaces');
        isInValid = true;
      }
      if (!lastName?.trim().length) {
        setLastNameErr('This is required.');
        isInValid = true;
      }else if(!nameRegex.test(lastName)){
        setLastNameErr('Last Name should contails letters and spaces');
        isInValid = true;
      }
      if (!dob) {
        setDOBErr('This is required.');
        isInValid = true;
      }

      if (ssn?.trim().length && ssn?.length !== 9) {
        setSSNErr('Enter valid SSN.');
        isInValid = true;
      }
      if (!(relation?.trim().length)) {
        setRelationErr('This is required.');
        isInValid = true;
      }
      if (!phoneNumber?.trim().length) {
          setphoneNumberErr('This is required.');
          isInValid = true;
      }  else if (phoneNumber.length !== 10) {
          setphoneNumberErr('Enter valid Phone Number.');
          isInValid = true;
      }
      // if (!altPhoneNumber?.trim().length) {
      //     setAltPhoneNumberErr('This is required.');
      //     isInValid = true;
      // }  else 
      if (altPhoneNumber && altPhoneNumber.length !== 10) {
        setAltPhoneNumberErr('Enter valid Alternate Phone Number.');
        isInValid = true;
      }
      if (!email?.trim().length) {
          setEmailErr('This is required.');
          isInValid = true;
      } else if (!formatters.isEmailValid(email)) {
          setEmailErr('Enter valid Email.');
          isInValid = true;
      }
      // if (!altEmail?.trim().length) {
      //   setAltEmailErr('This is required.');
      //   isInValid = true;
      // } else 
      if (altEmail && !formatters.isEmailValid(altEmail)) {
          setAltEmailErr('Enter valid Alternate Email.');
          isInValid = true;
      }
      if (!emergencyContactName?.trim().length) {
        setEmergencyContactNameErr('This is required.');
        isInValid = true;
      }else if(!nameRegex.test(emergencyContactName)){
        setEmergencyContactNameErr('Emergency Contact Name should contain letters and space');
        isInValid = true;
      }
      if (!emergencyContactNumber?.trim().length) {
        setEmergencyContactNumberErr('This is required.');
        isInValid = true;
      }  else if (emergencyContactNumber.length !== 10) {
        setEmergencyContactNumberErr('Enter valid Emergency Contact Number.');
        isInValid = true;
      }
      if(isInValid) {
        return;
      }
      const payload = {
        firstName: firstName,
        lastName: lastName,
        dateOfBirth: dob,
        socialSecurityNo: ssn, 
        relationshipCode: relation,
        phoneNo: phoneNumber,
        altPhoneNo: altPhoneNumber,
        email: email,
        altEmailId: altEmail,
        image: s3Key,
        emergencyContactName: emergencyContactName,
        emergencyContactNo: emergencyContactNumber,
      }
      const finalObject = {...user,...payload};
      updateProfileInfo(finalObject)
    };
  
  return (
    <Grid container style={{margin: 0, width: '100%'}}>
  <div className="profile-header-container">

    
  <Grid container className="profile-top-container" >
      {/* <Grid item xs={1} md={1} lg={1}></Grid> */}
      <Grid
         container
        xs={12}
        md={12}
        lg={12}
        className="profile-box-container"
      >
        {/* <Grid container spacing={2} style={{margin:0}}> */}
            <Grid  xs={12} sm={6} md={6} className="profile-left-box">
                <div className="edit-avatar-container" >
                    {imageUrlAvatar ? (
                      <img src={imageUrlAvatar} alt='UserAvatar' className='avatar-upload-icon' />
                    ) :(
                      <>
                      {!selectedImage && !imageUrlAvatar &&  (
                         <img src={UserAvatar} alt='UserAvatar' />
                     )}
                     </>
                    )}
                   
                    <input
                    accept="image/*"
                    type="file"
                    id="select-image"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      setImage(e.target.files[0]);
                      setSelectedImage(e.target.files[0])
                    }}
                    />
                    {/* <label htmlFor="select-image"> */}
                        <div  className="edit-icon-container" onClick={()=> {setOpenPhotoUploadModal(true)}}>
                            <img src={Edit} alt='edit'/>
                        </div>
                    {/* </label> */}
                </div>
                <div className="input-container-btm">
                  <div>
                      <Typography className='font-normal-small error-message'>{firstNameErr}</Typography>
                      <Typography className='font-normal-small profile-input-label'>{t("First Name")} <span style={{color:"red"}}>{" *"}</span></Typography>
                      <input className={`profile-input ${firstNameErr !== '' ? 'err-input' : ''}`}  aria-label='first name'  onChange={(e)=> {onChangeInput(e, 'firstName')}} value={firstName}/>
                  </div>
                  <div>
                      <Typography className='font-normal-small error-message'>{lastNameErr}</Typography>
                      <Typography className='font-normal-small profile-input-label'>{t("Last Name")} <span style={{color:"red"}}>{" *"}</span></Typography>
                      <input className={`profile-input ${lastNameErr !== '' ? 'err-input' : ''}`}  aria-label='last name'  onChange={(e)=> {onChangeInput(e, 'lastName')}} value={lastName}/>
                  </div>
                  <div>
                    <Typography className='font-normal-small error-message'>{dobErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Date of Birth")} <span style={{color:"red"}}>{" *"}</span></Typography>
                    <DatePicker minDate={new Date(1900, 0, 1)} className={`profile-input ${dobErr !== '' ? 'err-input' : ''}`}  onChange={(e)=> {onChangeInput(e, 'dob')}} value={dob} maxDate={new Date()} />
                </div>
                <div>
                    <Typography className='font-normal-small error-message'>{ssnErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Social Security Number")} </Typography>
                    <input className={`profile-input ${ssnErr !== '' ? 'err-input' : ''}`}  aria-label='ssn'  onChange={(e)=> {onChangeInput(e, 'ssn')}} maxLength={11} value={ssn ? formatters.formatSSNNumber(ssn): ssn}/>
                </div> 
                </div>
            </Grid>
            <Grid  xs={12} sm={6} md={6} className="profile-right-box"  >
                
                <div> 
                    <Typography className='font-normal-small error-message'>{relationErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Relationship with Plan Owner")} <span style={{color:"red"}}>{" *"}</span></Typography>
                    <FormControl style={{marginRight: 0, marginLeft:0, marginTop: 0, marginBottom: 25, width: '100%'}}>
                      <Select
                        labelId="demo-simple-select-label"
                        className="relation-select"
                        label="Relation"
                        value={(value) => {
                          return (
                            <Box sx={{ display: "flex", gap: 1 }}>
                              {relation}
                            </Box>
                          );
                        }}
                        onChange={(e)=> {onChangeInput(e, 'relation')}}
                        renderValue={(value) => {
                          return (
                            <Box sx={{ display: "flex", gap: 1 }}>
                              {relationship[relation]}
                            </Box>
                          );
                        }}
                      >
                        <div className="relation-select-div">
                        {
                          Object.keys(relation === 'self' ? filteredDataSelf : filteredDataNotSelf).map((item) => {
                            return ((relation === item || userDetails.userRoleCode === "admin" ||userDetails.userRoleCode === "owner")  && <MenuItem  value={item}>{relationship[item]}</MenuItem>)
                            })
                        }
                        </div>
                      </Select>
                    </FormControl>
                    {/* <input className={`profile-input ${relationErr !== '' ? 'err-input' : ''}`}  aria-label='relation'  onChange={(e)=> {onChangeInput(e, 'relation')}} value={relation}/> */}
                </div>
                <div>
                <Typography className='font-normal-small error-message'>{phoneNumberErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Phone Number")} <span style={{color:"red"}}>{" *"}</span></Typography>
                    <input className={`profile-input ${phoneNumberErr !== '' ? 'err-input' : ''}`} aria-label='phone number' onChange={(e)=> {onChangeInput(e, 'phoneNumber')}}  maxLength={10} value={formatters.formatPhoneNumber(phoneNumber)}/>
                </div>
                <div>
                <Typography className='font-normal-small error-message'>{altPhoneNumberErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Alternate Phone Number")}</Typography>
                    <input className={`profile-input ${altPhoneNumberErr !== '' ? 'err-input' : ''}`} aria-label='alternate phone number' onChange={(e)=> {onChangeInput(e, 'altPhoneNumber')}}  maxLength={10} value={formatters.formatPhoneNumber(altPhoneNumber)}/>
                </div>
                <div>
                <Typography className='font-normal-small error-message'>{emailErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Email ID")} <span style={{color:"red"}}>{" *"}</span></Typography>
                    <input className={`profile-input ${emailErr !== '' ? 'err-input' : ''}`}  aria-label='email'  onChange={(e)=> {onChangeInput(e, 'email')}} value={email} disabled/>
                </div>
                <div>
                <Typography className='font-normal-small error-message'>{altEmailErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Alternate Email ID")}</Typography>
                    <input className={`profile-input ${altEmailErr !== '' ? 'err-input' : ''}`}  aria-label='alternate email'  onChange={(e)=> {onChangeInput(e, 'altEmail')}} value={altEmail}/>
                </div>
                <div>
                <Typography className='font-normal-small error-message'>{emergencyContactNameErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Emergency Contact Name")}<span style={{color:"red"}}>{" *"}</span></Typography>
                    <input className={`profile-input ${emergencyContactNameErr !== '' ? 'err-input' : ''}`} aria-label='Emergency contact name' onChange={(e)=> {onChangeInput(e, 'emergencyContactName')}}  value={emergencyContactName}/>
                </div>
                <div>
                <Typography className='font-normal-small error-message'>{emergencyContactNumberErr}</Typography>
                    <Typography className='font-normal-small profile-input-label'>{t("Emergency Contact Number")}<span style={{color:"red"}}>{" *"}</span></Typography>
                    <input className={`profile-input ${emergencyContactNumberErr !== '' ? 'err-input' : ''}`} aria-label='Emergency contact number' onChange={(e)=> {onChangeInput(e, 'emergencyContactNumber')}}  maxLength={10} value={formatters.formatPhoneNumber(emergencyContactNumber)}/>
                </div>
                
            </Grid>
            <div className="profile-action-holder">
                <Button variant="outlined" className="primary-font-bold-6 profile-action-btn profile-cancel-btn" onClick={()=> {navigate('/profile', {state:{dontShowSecurityLock : true}})}}>{t("Cancel")}</Button>
                <Button variant="outlined" className="primary-font-bold-6 profile-action-btn profile-save-btn" onClick={()=> {onSave()}}>{t("Save")}</Button>
            </div>
        </Grid>
        {openPhotoUploadModal && (
          <Dialog
          open={openPhotoUploadModal}
          onClose={handleClose}
          className="profile-photo-dialog"
          aria-labelledby="photo-dialog-title"
          aria-describedby="photo-dialog-description"
          >
              <DialogTitle id="photo-dialog-title" sx={{display:"flex",justifyContent:"space-between"}}>
                  <Typography className='primary-font-bold1 '>{t("Photo upload")}</Typography>
              {openPhotoUploadModal ? (
                  <img src={CloseIcon} alt="close-icon" style={{cursor: 'pointer',width:"21px"}} onClick={handleClose} sx={{
                      marginRight: '-30px',
                  }}/>
                  ) : null}
              </DialogTitle>
              <Divider />
              <DialogContent className="profile-dialog-content">
              <Grid container spacing={2} style={{height: '100%'}}>
                <Grid  xs={12} md={dob && (formatters.calculateAge(dob) > 17 ) ? 7 : 12} style={{height: '100%', overflowY: 'scroll'}}>
                  <Typography className='primary-font-medium profile-input-label' style={{textAlign:"center"}}>{t("Choose Avatar")}</Typography>
                  <div>
                    {AvatarIcon.map((item, i)=> {
                      return (
                       <div className='avatar-photo-icon' 
                       onClick={(e)=> {
                        setImageUrlAvatar1(item.imgSrc); 
                        setPreviewUrl(item.imgSrc);
                        setIsAvatarSelection(true)
                        setSelectedAvatarData(item)
                        setImageUrlAvatar(item.imgSrc)
                      }}> 
                        <Button><img  src={item.imgSrc} alt={item.imgAlt} /></Button> 
                      </div>
                      )
                    })}
                  </div>
                </Grid>
                <Grid item xs={12} md={dob && (formatters.calculateAge(dob) > 17 ) ? 5 : 1} style={{paddingLeft: 0}}>
                  {dob && (formatters.calculateAge(dob) > 17 ) && (
                    <label htmlFor="select-image"> 
                    <div className="profile-photo-upload-container drop_zone" onDragOver={handleDragOver} onDrop={handleOnDrop}>
                    <img  src={UploadImage} alt={'upload-avatar'} style={{cursor: 'pointer'}} />
                    <Typography className='font-normal-small profile-input-label'>{t("Drag and drop a file here or click")}</Typography>
                    { previewUrl && <div className="image">
                      <img src={previewUrl} alt='image' width={100} height={100}/> 
                    </div> }
                    </div>
                    </label>
                  )}
                </Grid>
              </Grid>
              </DialogContent>
              <Divider />
              <DialogActions>
              <div className="profile-action-holder" style={{marginTop: 20, marginBottom: 20}}>
                  <Button variant="outlined" className="primary-font-bold-6 profile-action-btn profile-cancel-btn" onClick={handleClose}>{t("Cancel")}</Button>
                  <Button variant="outlined" className="primary-font-bold-6 profile-action-btn profile-save-btn" onClick={saveAvatarIcon}>{t("Upload")}</Button>
              </div>
              </DialogActions>
          </Dialog>
        )}
      </Grid>
      {/* <Grid item xs={1} md={1} lg={1}></Grid> */}
    {/* </Grid> */}
    </div>
    </Grid>
  );
};


EditProfilePage.defaultProps = {
    isFetchingLogin: null,
    isFetchingRegister: null,
    isFetchingUserInfo: null,
    isUpdatingUserInfo:  null
  };
  
  function mapStateToProps(state) {
    return {
    userInfoData: state.login.userInfoData,
    isFetchingLogin: state.login.isFetching,
    isFetchingUserInfo: state.login.isFetchingUserInfo,
    updatedData: state.profile.updatedData,
    isUpdatingUserInfo: state.profile.isUpdatingUserInfo,
    profilePictureData: state.profile.profilePictureData,
    profilePictureError: state.profile.profilePictureError,
    relationship: state.profile.relationship
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        getProfileInfo,
        getRelationshipList,
        updateProfileInfo,
        updateProfilePicture
      },
      dispatch
    );
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditProfilePage);